export const AcceptanceReasons = [
  'IBAN_DOES_NOT_EXIST',
  'ACCOUNT_IS_LOCKED',
  'ACCOUNT_IS_MORTGAGED',
  'REQUEST_IS_INCOMPLETE',
  'WARRANT_WAS_RECALLED',
  'SIGNATURE_DOES_NOT_MATCH',
  'USER_RECLAIMS_WARRANT',
  'MORE_WARRANTS_REQUIRED',
  'ACCOUNT_IS_NOT_EURO',
  'CUSTOM'
];
